import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

const FullScreenLoader = ({ text = 'Загрузка...' }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(10,10,10,0.6)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        zIndex: 2000,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress color="primary" />
        <Typography variant="body1" sx={{ color: 'white', opacity: 0.9 }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default FullScreenLoader;


